import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'analytics-vdc-filters';

export const CLEAR_SELECTED_FILTERS = `${NAMESPACE}/CLEAR_SELECTED_FILTERS`;
export const SELECT_FILTER_ITEMS = `${NAMESPACE}/SELECT_FILTER_ITEMS`;
export const SELECT_DATE_FILTER = `${NAMESPACE}/SELECT_DATE_FILTER`;
export const REMOVE_FILTER_ITEM = `${NAMESPACE}/REMOVE_FILTER_ITEM`;
export const SET_FILTER_ITEMS = `${NAMESPACE}/SET_FILTER_ITEMS`;
export const SET_FILTERS_FROM_URL = `${NAMESPACE}/SET_FILTERS_FROM_URL`;

export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const INITIALIZE = `${NAMESPACE}/INITIALIZE`;

export const FETCH_FILTERS = createApiConstants(NAMESPACE, 'FETCH_FILTERS');
export const FETCH_USERS = createApiConstants(NAMESPACE, 'FETCH_USERS');
export const FETCH_TEAMS = createApiConstants(NAMESPACE, 'FETCH_TEAMS');
export const SEARCH_METADATA = createApiConstants(NAMESPACE, 'SEARCH_METADATA');
